import { makeAutoObservable } from 'mobx';
import type { FinancialInstitutions } from '@melio/payments-recon-api-client-ts';
import { lastBusinessDay } from '@tools/ui-utils/business-day.util';
import datesUtil from '@tools/ui-utils/dates.util';
import { reconEnumValue } from '../utils/reconEnumValue';

const initialSearchParams = new URLSearchParams(window.location.search);

class RecoStore {
  isClosingStatusSidebarVisible = false;

  startDate: string = initialSearchParams.has('from')
    ? datesUtil.formatDate(
        initialSearchParams.get('from') as string,
        'YYYY-MM-DD'
      )
    : lastBusinessDay.format('YYYY-MM-DD');

  endDate: string = datesUtil.formatDate(
    initialSearchParams.get('to') || Date(),
    'YYYY-MM-DD'
  );

  vendorBalanceDate: string = datesUtil.formatDate(Date(), 'YYYY-MM-DD');

  vendorBalanceFinancialInstitution: FinancialInstitutions =
    reconEnumValue<FinancialInstitutions>('jpm');

  constructor() {
    makeAutoObservable(this);
  }

  setVendorBalanceFinancialInstitution(
    financialInstitution: FinancialInstitutions
  ) {
    this.vendorBalanceFinancialInstitution = financialInstitution;
  }

  getVendorBalanceFinancialInstitution() {
    return this.vendorBalanceFinancialInstitution;
  }

  setSelectedDates(from: string, to: string): void {
    this.startDate = from;
    this.endDate = to;
  }

  setVendorBalanceDate(date: string): void {
    this.vendorBalanceDate = date;
  }

  getVendorBalanceDate(): string {
    return this.vendorBalanceDate;
  }

  toggleClosingStatusSidebarVisibility(
    isVisible = !this.isClosingStatusSidebarVisible
  ): void {
    this.isClosingStatusSidebarVisible = isVisible;
  }
}

export default new RecoStore();
